var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-box"},_vm._l((_vm.list),function(count){return _c('div',{key:count + 'status',staticClass:"statusList"},[(count % 2 == 1)?_c('div',{staticClass:"status",style:({
        background:
          (count / 2).toFixed(0) <= _vm.currentStatus ? '#3377FF' : '#C2C5CC',
      })},[_vm._v(" "+_vm._s((count / 2).toFixed(0))+" "),_c('div',{staticClass:"statusText"},[_vm._v(" "+_vm._s(_vm.getStatusText((count / 2).toFixed(0)))+" ")])]):_c('div',{staticClass:"status-line",style:({
        background: count / 2 < _vm.currentStatus ? '#3377FF' : '#C2C5CC',
      })})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }